module.exports = __webpack_public_path__ + "static/jardins_all_lagarto-e46939d9944b70fb57e3067373d5849b.jpg";